'use client'

import Image from 'next/image'
import BusinessModals from '@components/BusinessModal/businessModals'
import { useState } from 'react'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import styles from './herosection.module.scss'

const HeroSection = ({ data }) => {
  const lob = data?.data?.lineOfBusiness
  const hwp = data?.data?.IntroHWP
  const introImage = data?.data?.IntroImages?.[0]?.Assets?.data?.[0]?.attributes?.url
  const {
    ctaPrompt,
    ctaText,
    ctaFormSnippet,
    redirectPrompt,
    redirectText,
    redirectUrl,
    redirectIcon,
    redirectPeepIcon,
    benefits,
  } = data?.data
  const onClickRedirect = () => {
    window.location.href = redirectUrl
  }
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div className={styles.body1}>
      <div className={styles.heroMainPage}>
        <div className={styles.lobName}>{lob}</div>
        <div className={styles.headingParagraph}>
          {hwp?.map((item, index) => {
            const textClass = item?.type
            return <h1 className={styles[textClass]}>{item?.children?.[0]?.text}</h1>
          })}
        </div>
        {benefits?.length > 0 && (
          <div className={styles.benefitsContainer}>
            {benefits.map(benefit => (
              <div className={styles.benefitItem}>
                <Image
                  className={styles.benefitIcon}
                  width={24}
                  height={24}
                  src={benefit?.icon?.data?.attributes?.url}
                  alt="benefit"
                />
                <p>{benefit?.label}</p>
              </div>
            ))}
          </div>
        )}
        {ctaText && ctaPrompt && (
          <div className={styles.ctaSection}>
            <button type="button" className={styles.ctaButton} onClick={() => setIsModalOpen(true)}>
              {ctaText}
            </button>
            <p className={styles.ctaPrompt}>{ctaPrompt}</p>
            <BusinessModals isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} content={ctaFormSnippet} />
          </div>
        )}
        <PropertyControlledComponent
          controllerProperty={redirectText && redirectPrompt && redirectUrl && redirectIcon}
          fallback={null}>
          <div className={styles.redirectSectionWrapper}>
            <div className={styles.redirectSectionContainer}>
              <Image
                className={styles.redirectPeepIcon}
                width={56}
                height={56}
                src={redirectPeepIcon?.data?.attributes?.url}
                alt="calculator icon"
              />
              <button type="button" className={styles.redirectSection} onClick={onClickRedirect}>
                <p>{redirectPrompt}</p>
                <p className={styles.redirectText}>
                  {redirectText}
                  <Image
                    className={styles.redirectIcon}
                    width={32}
                    height={32}
                    src={redirectIcon?.data?.attributes?.url}
                    alt="redirect icon"
                  />
                </p>
              </button>
            </div>
          </div>
        </PropertyControlledComponent>
        {introImage && (
          <div className={styles.introImageContainer}>
            <Image
              width={587}
              height={548}
              src={introImage}
              alt="header iamge"
              loading="lazy"
              decoding="async"
              className={styles.desktopIntroImage1}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default HeroSection
